import { ReactNode, useState } from "react";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/solid";

interface DataTableProps {
  headers: string[];
	data: string[][];
  title: ReactNode;
}

const TableHeader = ({ title }: { title: string }) => {
  return (
    <th
      className="p-2 font-medium text-xs leading-none text-gray-700 bg-gray-100 uppercase tracking-wider sticky -top-1 z-10"
      scope="col"
    >
      {title}
    </th>
  );
};

const TableData = ({ data }: { data: string }) => {
  return (
    <td className="px-2 py-3 whitespace-nowrap font-medium text-xs leading-none text-gray-700">
      <div className="flex items-center justify-center flex-shrink-0 h-full">
        <div className="truncate">{data}</div>
      </div>
    </td>
  )
};

const Row = ({ data }: { data: string[] }) => {
  return (
    <tr>
      {data.map((datum, index) => (
        <TableData key={index} data={datum} />
      ))}
    </tr>
  );
};

const DataTable = ({ headers, data, title }: DataTableProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between mx-7 mt-4 mb-0">
        {title}
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="p-2 hover:bg-gray-100 rounded-full transition-colors"
        >
          {isCollapsed ? (
            <ChevronDownIcon className="w-5 h-5 text-gray-600" />
          ) : (
            <ChevronUpIcon className="w-5 h-5 text-gray-600" />
          )}
        </button>
      </div>
      {!isCollapsed && (
        <div className={`overflow-auto max-h-[600px] mt-0 mx-7 mb-0 rounded-[5px]`}>
          <table className="min-w-full h-[1px]">
            <thead>
              <tr>
                {headers.map((header) => (
                  <TableHeader key={header} title={header} />
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-300">
						{!data.length && (
          <tr>
            <td colSpan={headers.length} className="text-center p-2 text-gray-400">
              No Records found
            </td>
          </tr>
        )}
        {data.map((datum, index) => (
          <Row data={datum} key={index.toString()} />
        ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DataTable; 